module.exports = __webpack_public_path__ + "img/work.5a2f8d44.png";